/** @jsx jsx */

import { Grid, SkeletonText, Surface, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import ColorSquare from './ColorSquare';

const Styles = {
  root: css`
    padding: 15px;
  `,
};

export type CategoryType = {
  count: number;
  key: string;
  label: string;
};

type Props = {
  data: Array<CategoryType>;
  isLoading: boolean;
};

function Category({ data, isLoading }: Props) {
  return (
    <figcaption data-testid="Category">
      <Surface borderColor="GrayWarm4">
        <div css={Styles.root}>
          <Grid columns={1} gap={10}>
            <Text tag="h3" type="Body4">
              Category
            </Text>
            {data.map(({ key, label, count }) => (
              <Grid
                alignItems="center"
                columns="10px 50% auto"
                gap="5px"
                key={key}
              >
                <ColorSquare colorKey={key} /> <Text>{label}</Text>
                {isLoading ? (
                  <SkeletonText lines={1} />
                ) : (
                  <Text>({count})</Text>
                )}
              </Grid>
            ))}
          </Grid>
        </div>
      </Surface>
    </figcaption>
  );
}

export default Category;
